export function loadFile(e, success) {
  try {
    const file = e.target.files[0];
    let reader = new FileReader();

    reader.onload = (function (_theFile) {
      console.log("load file");
      console.log(_theFile);
      return function (e) {
        success(e.target.result, _theFile.name, _theFile.type);
      };
    })(file);
    reader.readAsArrayBuffer(file);
  } catch (error) {
    console.log(error.message);
  }
}

export function selectColorMarker(category) {
  const mapping = {
    "Sonidos y sociedad": "/purple-dot.png",
    "Sonidos mecánicos": "/yellow-dot.png",
    "Sonidos humanos": "/blue-dot.png",
    "Sonidos Naturales": "/green-dot.png",
  };
  return mapping[category] !== undefined ? mapping[category] : "/red-dot.png";
}

export function validateNum(numStr, min, max) {
  try {
    let num = parseFloat(numStr);
    return min <= num && num <= max;
  } catch (error) {
    return false;
  }
}

export function markerInRange(mapRanges, locationLat, locationLng) {
  const { ne, nw, se, sw } = mapRanges.bounds;
  const conditionLat = sw.lat <= locationLat && locationLat <= nw.lat;
  const conditionLng = sw.lng < locationLng && locationLng < se.lng;
  return conditionLat && conditionLng;
}
